export const AVAILABLE_MODELS = [
  'best_quality',
  'fast',
  'ultrafast_text',
  'ultrafast_vision'
];

export const DEFAULT_MODEL = 'fast';
